import { Action, ErrorCodes, OperationType, Position } from "puzzle";
import AssignSupplier from "../components/SubmissionsList/ActionToolbar/SelectSuppliers/AssignSupplier/AssignSupplier";

export const assignDialogSaveButtonUpdate: Action = [{
  buttons: [{
    name: 'selectSuppliers.save',
    disabled: '{saveButtonDisabled}'
  }],
  type: OperationType.updateDialog
}];

export const openAssignSupplier: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'getProjectId',
  mappingName: 'projectId',
  type: OperationType.addOperationData
}, {
  children: [{
    render: AssignSupplier,
    propArgs: [
      'includeRacu',
      'onChange',
      'phase',
      'phaseSuppliers',
      'projectId',
      'sourceLanguageLocale',
      'targetLanguageLocale'
    ]
  }],
  className: 'md assign-suppliers',
  items: [{
    btnName: 'selectSuppliers.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'selectSuppliers.save',
    btnConfig: {
      themeColor: 'primary',
      disabled: true,
      pos: Position.end
    },
    operations: [{
      moduleName: 'AssignSupplier',
      name: 'updateSuppliersList'
    }]
  }],
  title: 'selectSuppliers.assign',
  type: OperationType.dialog
}];

export const getUsersAssignDialog: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: "{url}"
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'organizationUsersResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{organizationUsersResponse}',
        organizationUsers: '{organizationUsersResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  evaluate: true,
  moduleName: 'AssignDialogDropdown',
  name: 'setGridData',
  args: ['organizationUsers'],
  moduleId: '{moduleId}'
}, {
  condition: '{autoPopulate} && {organizationUsersResponse}?.users?.length === 1',
  conditionOperations: [{
    evaluate: true,
    moduleName: 'AssignDialogDropdown',
    name: 'autoPopulateSupplier',
    moduleId: '{moduleId}'
  }, {
    data: {
      saveButtonDisabled: false
    },
    name: 'assignDialogSaveButtonUpdate',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];
